import chainRpcs from "data/chainRpc";
import { ChainRpc, ChaingeChain, RpcInfo, WagmiChainType } from "types/baseType";
import { Chain } from "viem";

export const DEF_MIN_USDT = 5
export const DEF_TOKEN_ADDRESS = '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee'
export const SERVICE_FEE_RATE_MOL = 5
export const SERVICE_FEE_RATE_DEN = 10000
export const ICON_URL = 'https://icon.chainge.finance/'
export const MINTER = '0x8A4AA176007196D48d39C89402d3753c39AE64c1'
export const GAS_MINTER = '0x8A4AA176007196D48d39C89402d3753c39AE64c1'
export const GAS_TO_ADDR = '0x42a6685ef29886Cbcb595Aa903f00dea0d1787d8'



// 短字符串
export const shortStr = (str: string, num: number = 5) => {
    if(str.length <= num) {
        return str
    }
    return str.substring(0, num) + '...' + str.substring(str.length - num)
}

// 格式化wagmi类型的链
export const formatWagmiChains = (
    chain: ChaingeChain,
  ) : Chain => {
    const curRpcInfo = (chainRpcs as ChainRpc)[chain.network] as RpcInfo
    const tempChain: WagmiChainType = {
        id: +chain.network,
        name: chain.fullName,
        network: chain.fullName,
        nativeCurrency: {
            decimals: chain.decimals,
            name: chain.fullName,
            symbol: chain.baseCoin,
        },
        rpcUrls: {
            public: { http: [curRpcInfo.rpcUrl ]},
            default: { http: [curRpcInfo.rpcUrl] },
        },
        blockExplorers: {
            default: { name: chain.fullName, url: curRpcInfo.scanUrl },
        },
        iconIndex: chain.chainIndex,
    };
    return tempChain
  };

// 格式化数字
export const formatNum = (num: number | string, decimal?: number) => {
    num = +num as number
    const options = {maximumFractionDigits: decimal || 20};
    const formatNumStr = num.toLocaleString(undefined, options)
    return formatNumStr
}

// 拼接icon 链接
export const getIconUrl = (index: string | number | undefined, name: string | undefined, type: string = 'color') => {
    return `${ICON_URL}${index}_${name}_${type}.png`
}

// 设置滑点比率
export const getSlippageByToToken = (fromSymbol: string, toSymbol: string) => {
    const stableCoinList = ['USDT', 'USDC', 'DAI', 'BUSD', 'FRAX']
    const mainCoinList = ['BTC', 'ETH', 'BNB', 'TRX', 'MATIC', 'OP', 'ARB', 'ADA', 'AVAX', 'ATOM', 'INJ', 'DOT', 'SUSHI', 'WISE','VVS', 'ILV', 'MKR', 'Cake', 'LINK', 'BOO', 'GMX', 'YOSHI', 'LIF3', 'LSD', 'MNT', 'OLAS', 'ELON', 'BRUSH', 'MAGIC', 'MBOX', 'CAW', 'BEAM', 'HERO', 'GNO', 'PEPE', 'MIM', 'WIGO', 'GRAI', 'UNI', 'TOMB', 'MMX', 'PAXG', 'MC', 'PUNK', 'DEUS', 'DELTA', 'SFUND', 'BONE', 'GRAIL', 'WAXE', 'FLC', 'LON', 'RFD', 'SHIB', 'RDPX', 'CAGA', 'JPEG', 'WOO', 'BTT', 'STARL', 'LDO', 'SYN', 'DEBT', 'DEXT', 'GEKKO', 'STG']
    const burnCoinList = ['BABYDOGE', 'RYIU', 'HOICHI', 'FLOKI', '0X0']
    fromSymbol = fromSymbol.toUpperCase()
    toSymbol = toSymbol.toUpperCase()
    if(stableCoinList.includes(fromSymbol) && stableCoinList.includes(toSymbol)) {
        return 0.1
    } else if(mainCoinList.includes(fromSymbol) && mainCoinList.includes(toSymbol)) {
        return 0.5
    } else if((mainCoinList.includes(fromSymbol) || mainCoinList.includes(toSymbol)) && !burnCoinList.includes(fromSymbol) && !burnCoinList.includes(toSymbol)) {
        return 0.5
    } else if(burnCoinList.includes(fromSymbol) || burnCoinList.includes(toSymbol)) {
        return 20
    } else {
        return 3
    }
}


// 判断是否是手机端
export const checkMobile = () => {
    const ua = navigator.userAgent;
    const isIOS = /iphone|ipad|ipod|ios/i.test(ua);
    const isAndroid = /android|XiaoMi|MiuiBrowser/i.test(ua);
    const isMobile = isIOS || isAndroid;
    return isMobile
}


// 格式化滑点为万分制
export const formatSlippageToPerTenThousand = (slippage: string) => {
    let slippageNum = +slippage
    slippageNum *= 100
    return slippageNum+''
}